import { useCallback } from "react";
import { Periodo } from "../__types";

export const useOrdenarPeriodos = () => {
    return useCallback((periodos: Periodo[]) => {
        return [...periodos].sort((a, b) => {
            if (typeof a.periodo !== 'string' || typeof b.periodo !== 'string') return 0;

            const [anoA, periodoA] = a.periodo.split('-').map(Number);
            const [anoB, periodoB] = b.periodo.split('-').map(Number);

            if ([anoA, periodoA, anoB, periodoB].some(isNaN)) return 0;

            return anoA - anoB || periodoA - periodoB;
        });
    }, []);
};
